import htmlToDraft from 'html-to-draftjs';

export const fromHtml = value => {
    const contentBlock = htmlToDraft(value);

    return contentBlock;
}